class PurchaseOptions extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.productFormId);
    this.dynamicCheckout = this.form ? this.form.querySelector('.shopify-payment-button') : null;
    if (!this.dynamicCheckout) return;

    this.addEventListener('change', () => this.sync());
    this.sync();
  }

  sync() {
    const selected = this.querySelector('input[type="radio"]:checked');
    this.dynamicCheckout.hidden = !!(selected && selected.value);
  }
}

if (!customElements.get('purchase-options')) {
  customElements.define('purchase-options', PurchaseOptions);
}
